<template lang="pug">
  app-toolbar-item(label="Период" :items="items" key-name="title") 
    slot

    template(slot="append")
      app-dialog-date-picker(v-model="dialogDay" ref="dialogDay" type="day" @confirm="$_filterByPeriod")
      app-dialog-date-picker(v-model="dialogMonth" ref="dialogMonth" type="month" @confirm="$_filterByPeriod")
</template>

<script>
import { $_app_moment } from "@/common/AppMoment.js"

export default {
  inheritAttrs: true,
  name: 'app-toolbar-item-period',
  mixins: [ $_app_moment ],

  props: {
    showAll: {
      type: Boolean,
      default: true
    },
  },

  methods: {
    $_chooseDay () {
      this.$refs.dialogDay.show()
    },

    $_chooseMonth () {
      this.$refs.dialogMonth.show()
    },

    $_filterByPeriod (period) {
      this.$emit('select', period)
    }
  },

  computed: {
    items () {
      return this.showAll ? this.$_period_items : this.$_period_items.slice(1, this.$_period_items.length)
    }
  },

  data () {
    return {
      dialogDay: false,
      dialogMonth: false,
    }
  }
}
</script>